import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    text: {
        flexShrink: 1,
        minWidth: 0
    },
    group: {
        width: "100%"
    }
});
export default stylesheet;
